import React, { useState } from "react";
import { useTranslate } from "@tolgee/react";
import {
  Hero, Globe, Title, Subtitle, Fields, PrimaryBtn, BackBtn, EmailBadge, ErrorText, TextLink, PasswordInput, TermsFooter
} from "../shared/AuthUI";
import { signInWithEmail, sendPasswordResetOtp } from "../../../API/emailAuth";
import { getAuthErrorMessage } from "../../../API/emailAuthErrors";

const EmailPasswordStep = ({
  email,
  onBack,
  onSignInSuccess,
  onGoReset,
  setIsLoading,
}) => {
  const { t } = useTranslate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const handleSignIn = () => {
    if (!password) return;
    setError(null);
    setIsLoading(true);
    signInWithEmail(
      email,
      password,
      (response) => {
        setIsLoading(false);
        onSignInSuccess(response.data.token, response.data.refresh_token);
      },
      (err) => {
        setIsLoading(false);
        setError(getAuthErrorMessage(err?.response?.data?.error, t));
      }
    );
  };

  const handleForgotPassword = () => {
    setIsLoading(true);
    sendPasswordResetOtp(
      email,
      () => { setIsLoading(false); onGoReset(); },
      () => { setIsLoading(false); onGoReset(); }
    );
  };

  return (
    <>
      <BackBtn onClick={onBack}>{t("general.back")}</BackBtn>

      <Hero>
        <Globe>🔐</Globe>
        <Title>{t("authentication.password.title")}</Title>
        <Subtitle>{t("authentication.password.subtitle")}</Subtitle>
      </Hero>

      <EmailBadge>{email}</EmailBadge>

      <Fields>
        <PasswordInput
          value={password}
          onChange={(e) => { setPassword(e.target.value); setError(null); }}
          placeholder={t("authentication.password.placeholder")}
          autoComplete="current-password"
          autoFocus
          onKeyDown={(e) => { if (e.key === "Enter") handleSignIn(); }}
        />

        {error && <ErrorText>{error}</ErrorText>}

        <PrimaryBtn disabled={!password} onClick={handleSignIn}>
          {t("authentication.password.signin_button")}
        </PrimaryBtn>

        <TextLink onClick={handleForgotPassword}>{t("authentication.password.forgot_link")}</TextLink>
      </Fields>

      <TermsFooter />
    </>
  );
};

export default EmailPasswordStep;
